module.exports = __webpack_public_path__ + "img/1483295164.6094c435.jpg";